<template>

    <el-header :class="['header-box ']">
        <div class="mean-box flex  flex-align-center flex-space-between">
            <!--  logo  -->
            <div><img src="@/assets/imgs/logo2.png"></div>
            <div class="menu-lists flex flex-align-center">
                <ul class="flex flex-align-center">
                    <li
                        class="cursor-pointer"
                        :class="{checked: item.includePah.includes(selectPath)}"
                        v-for="(item,i) in list"
                        @click="handleRouter(item)" :key="i">{{ item.name }}
                    </li>
                </ul>
    <!--            <div class="xcx-box cursor-pointer" @click="handleWx()">微信小程序 <i class="el-icon-arrow-down"></i></div>-->
            </div>
        </div>
        <!--   输入框     -->
        <div class="ipt-box">
            <el-input
                placeholder="请输入关键词"
                v-model="ipt">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button class="btn" @click="handleSearch">检索</el-button>
        </div>

        <!--   微信小程序的弹窗     -->
        <Dialog :dialog-visible.sync="dialog" title="微信小程序"  :show-submit-btn="false">
            <img class="img-box" src="@/assets/imgs/home.png">
        </Dialog>

    </el-header>
</template>

<script setup>
import {computed, onMounted, ref, watch} from 'vue'

import { menuLists } from '@/util/const'
import { useRoute, useRouter } from 'vue-router/composables'
import QRcode from 'qrcodejs2'
import Dialog from "@/components/dialog.vue";


const route = useRoute()
const router = useRouter()


let selectPath = ref(null)
let ipt = ref(null)  //输入框的值
const list = menuLists
let dialog = ref(false)
let code = null
const handleRouter = (item) => {
    selectPath.value = item.path
    router.push(item.path)
}

// 打开小程序二维码
const handleWx =()=>{
    dialog.value = true
    // if(code) return
    // setTimeout(()=>{
    //     code = new QRcode('qrCode', {
    //         width: 200, // 生成二维码宽度
    //         height: 200, // 生成二维码高度
    //         text: 'url地址', // 二维码地址或文本，如果是网址扫码后会跳转网址
    //         colorDark: '#000',
    //         colorLight: '#fff'
    //     })
    // },10)
}


watch(()=> route.path,val=>{
    selectPath.value = val
})

const handleSearch = () => {
    // if (!ipt.value) {
    //     return
    // }
    router.push({
        path: '/bookSearch',
        query: {
            keyword: ipt.value
        }
    })
}

onMounted(() => {
    selectPath.value = route.path
    if(!route.query.keyword) {
        ipt.value = ''
    } else {
        ipt.value = route.query.keyword
    }
})

</script>

<style lang="scss" scoped>
.header-box {
    height: 184px !important;
    background: #ffffff;
    //position: relative;
    z-index: 9;

    img {
        width: 359px;
        height: 81px;
    }

    .menu-lists {
        width: calc(100% - 359px);
        justify-content: center;
        li {
            //width: 85px;
            height: 100%;
            padding: 0 30px;
            text-align: center;
            line-height: 109px;
            color:#101010;
            font-size:16px;
            position: relative;

            &:hover {
                color:#066a76
            }

            &.checked {
                color:#066a76;


                &:after{
                    content: '';
                    position: absolute;
                    bottom: 25%;
                    left: 0;
                    right: 0;
                    margin: auto;
                    width: 52px;
                    height: 4px;
                    background: #066a76;
                }
            }

        }
    }

    .xcx-box {
        color: #ffffff;
        font-size: 16px;
        width: 147px;
        height: 47px;
        border: 1px solid rgba(255, 255, 255, .3);
        border-radius: 24px;
        text-align: center;
        line-height: 45px;
        box-sizing: border-box;
        margin-left: 30px;

        i {
            margin-left: 5px;
        }
    }
}
.img-box{
    width: 300px;
    height: 300px;
}
.mean-box{
    width: 1200px;
    margin: auto;
}
.ipt-box{
    width: 1200px;
    margin: auto;
    font-family:Source Han Sans CN;
    color:#303030;
    font-size:20px;
    position: relative;

    i{
        color: #188b97;
        font-size: 20px;
    }
    ::v-deep .el-input__inner{
        height: 50px;
        padding: 0 35px;
    }
    .btn{
        width: 129px;
        height: 43px;
        line-height: 43px;
        background: #188b97;
        font-family:Source Han Sans CN;
        color:#ffffff;
        font-size:20px;
        position: absolute;
        top: 3.5px;
        right: 10px;
        letter-spacing: 5px;
        padding: 0;
    }
}
</style>
